import { useDispatch } from "react-redux";
import {
  getIleggelse,
  getIleggelseHistorikk,
  postIleggelserBilder,
} from "../../../actions/ileggelserActions";
import BilderButtons from "../../Common/Detalj/BilderButtons";

export default function BilderButtonsContainer({ id }) {
  const dispatch = useDispatch();

  function handleLeggTilBilderClick(invisibleFileInputRef) {
    invisibleFileInputRef.click();
  }

  function handleFileInputChange(fileArray) {
    const uploads = [];
    for (let index = 0; index < fileArray.length; index++) {
      uploads.push(
        dispatch(postIleggelserBilder(id, fileArray[index.toString()])),
      );
    }
    Promise.all(uploads)
      .then(() => dispatch(getIleggelse(id)))
      .then(() => dispatch(getIleggelseHistorikk(id)))
      .catch();
  }

  return (
    <BilderButtons
      handleFileInputChange={handleFileInputChange}
      handleLeggTilBilderClick={handleLeggTilBilderClick}
    />
  );
}
